<template>
  <div>
    <Menu />

    <div class="container main">
      <div class="row">
        <div class="col-md-12">
          <SectionTitle
            title="SESB"
            description=""
            url="/saude-bucal"
            :enabledModalInformacao="false"
            :enabledIframeModalInformacao="true"
            urlIframeModalInformacao=""
            pageIdentifier="sesb"
          />
        </div>

        <div class="col-md-12">
          <div class="construction-box">
            <i class="icofont-tools construction-icon"></i>
            <h2>Em construção</h2>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import Footer from '@/components/Footer'
import SectionTitle from '@/components/SectionTitle'

export default {
  name: 'Sesb',
  components: {
    Menu,
    Footer,
    SectionTitle,
  },
}
</script>

<style lang="scss">
.construction-box {
  margin-top: 40px;
  padding: 60px 20px;
  text-align: center;
  background: #f8f9fc;
  border: 1px dashed #d1d3e2;
  border-radius: 12px;
  transition: all 0.3s ease;

  .construction-icon {
    font-size: 80px;
    color: #000;
    margin-bottom: 20px;
  }

  h2 {
    font-size: 32px;
    font-weight: 600;
    color: #5a5c69;
    margin-bottom: 10px;
  }

  p {
    font-size: 16px;
    color: #858796;
  }
}
</style>
